export default __webpack_public_path__ + "static/media/menu.19c9ce62.jpeg";